var _defs, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArchive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "44px",
    height: "36px",
    viewBox: "0 0 44 36",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icons / settings / handsfree off") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("path", {
    d: "M40,6 L24,6 C22.896,6 22,6.896 22,8 L22,20 L17,20 C16.626,20 16.286,20.208 16.114,20.54 C16.038,20.684 16,20.842 16,21 C16,21.202 16.06,21.402 16.18,21.574 L23.18,31.574 C23.368,31.84 23.674,32 24,32 C24.326,32 24.632,31.84 24.82,31.574 L31.818,21.574 C32.034,21.268 32.058,20.868 31.886,20.54 C31.714,20.208 31.374,20 31,20 L26,20 L26,10 L40,10 C41.102,10 42,10.898 42,12 L42,36 C42,37.104 41.102,38 40,38 L8,38 C6.898,38 6,37.104 6,36 L6,12 C6,10.898 6.898,10 8,10 L12,10 C13.104,10 14,9.104 14,8 C14,6.896 13.104,6 12,6 L8,6 C4.692,6 2,8.692 2,12 L2,36 C2,39.308 4.692,42 8,42 L40,42 C43.308,42 46,39.308 46,36 L46,12 C46,8.692 43.308,6 40,6",
    id: "path-1"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "MLP-deliverables",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Intro---add-background-Copy-6",
    transform: "translate(-657.000000, -450.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-4",
    transform: "translate(483.000000, 372.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icons-/-settings-/-handsfree-off",
    transform: "translate(172.000000, 72.000000)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "mask-2",
    fill: "white"
  }, /*#__PURE__*/React.createElement("use", {
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "Fill-1"
  }), /*#__PURE__*/React.createElement("rect", {
    id: "\\u21B3-icon-tint",
    fill: "#FFFFFF",
    fillRule: "nonzero",
    mask: "url(#mask-2)",
    x: 0,
    y: 0,
    width: 48,
    height: 48
  })))))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArchive);
export default __webpack_public_path__ + "static/media/archive.5a7277344175d9be14099613965ecdc6.svg";
export { ForwardRef as ReactComponent };